import React from "react";
import { DetailsBase } from "../base/DetailsBase";
import appService from "../../../services/app.service";
import { useTranslation } from "react-i18next";
import { NoAdminAlert } from "../../NoAdminAlert"

export const InterviewStatusDetails: React.FunctionComponent<{
    id: string | undefined;
    isAdmin:boolean;
}> = (props) => {
    const { id,isAdmin } = props;
    const { t } = useTranslation();
    const backButton = "/config/interviewstatus";
    const title = t("client:headers:tabInterviewStatus");

    if (isAdmin !== true) { return <NoAdminAlert /> }
    
    return (
        <DetailsBase id={id} backButton={backButton} getById={appService.getInterviewStatusById} hasNumber={true}  saveItem={appService.saveInterviewStatus} inputTitle={title}></DetailsBase>
    );
};
